/**
 * 「표로 보기」 데이터. 차트와 같은 사실을 표로 옮긴 것이라 차트 어댑터가 함께 만든다.
 * React에 의존하지 않아 bun:test로 검증한다.
 */
export interface VisualTableColumn {
  key: string;
  label: string;
  /** 수치 열: 우측 정렬 + tabular-nums */
  numeric?: boolean;
}

export interface VisualTableRow {
  key: string;
  cells: readonly (string | number)[];
  /** 행을 누르면 차트 막대를 누른 것과 같은 곳으로 이동(드릴스루). 키보드 Enter/Space도 같다. */
  onActivate?: () => void;
  /** 이동 대상 설명(스크린리더). 예: "완료 Task 보기" */
  activateLabel?: string;
}

export interface VisualTable {
  ariaLabel: string;
  columns: readonly VisualTableColumn[];
  rows: readonly VisualTableRow[];
}

/** 표 셀 값을 열 순서대로 꺼낸다(없으면 "—"). */
export function cellAt(row: VisualTableRow, index: number): string | number {
  return row.cells[index] ?? "—";
}
